<template>
  <flat-pickr :value="value" @input="$emit('input', $event)" :config="opt" class="form-control" @on-change=onChange />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      default: {
        wrap: true,
        altFormat: 'd.m.Y',
        altInput: true,
        // allowInput: true,
        enableTime: false
      }
    };
  },
  computed: {
    opt() {
      return { ...this.default, ...this.config };
    }
  },
  methods: {
    onChange(event, date) {
      this.$emit('on-change', event, date);
    }
  },
};
</script>
